import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import {remCalc} from '../../../theme/_utils'

const OrderSummaryDivider = () => {
    return <Box w={'100%'} h={remCalc(1)} bg="border.neutral.subtle"></Box>
}

export default OrderSummaryDivider
